import { useAuth } from "@clerk/react";
import axios from "axios";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DIETS = [
  { key: "vegetariano", label: "Vegetariano" },
  { key: "vegano", label: "Vegano" },
  { key: "senza_glutine", label: "Senza glutine" },
  { key: "senza_lattosio", label: "Senza lattosio" },
  { key: "veloce", label: "Veloci < 20 min" },
];

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, extra = {}) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` }, ...extra });
      return res.data;
    },
    [getToken]
  );
}

export const errMsg = (e) => e?.response?.data?.detail || "Qualcosa è andato storto, riprova.";

export async function resizeImage(file, max = 1600) {
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = URL.createObjectURL(file);
  });
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(img.width * scale);
  canvas.height = Math.round(img.height * scale);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  return new Promise((res) => canvas.toBlob((b) => res(b), "image/jpeg", 0.85));
}
